import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Marker } from '../../models/marker.model';
import { MAP_CONFIG } from '../../configs/map.config';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapComponent {

  @Input() readonly markers: Marker[];
  @Input() readonly maxZoom: number = MAP_CONFIG.maxZoom;

}

